import styled from 'styled-components';

type DropdownItemProps = {
  roleType?: 'view' | 'manage';
};

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  background-color:rgb(253, 253, 253);
  color: black;
  padding: 10px 16px;
  border: 1px solid rgb(104, 163, 223);
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  &:hover {
    background-color: rgb(104, 163, 223);
  }
`;

export const DropdownMenu = styled.div`
  position:absolute;
  top: calc(100% + 2px);
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  overflow: visible !important;
  z-index: 1002;
  
`;

export const DropdownItem = styled.div<DropdownItemProps>`
padding: 3px 5px;
font-size: medium;
display: flex;
align-items: center;
transition: background 0.2s;

&::before {
  content: "•";
  color: ${({ roleType }) =>
    roleType === "view" ? "rgb(70, 146, 222)" : "rgb(25, 73, 147)"};
  margin-right: 8px;
  font-size: 1.5em;
}

&:hover {
  background-color: rgb(223, 217, 217);
}
`;